<template>
    <div class="apprach">
        <div class="row u-top-margin--s-important" v-if="items && items.length">
            <div class="col-default-6 col-mobile-12"
                 v-for="(file, index) in items"
                 :key="index">
                <z-filelist>
                    <z-filelist-item
                        :icon="`file/${file.file.type}`"
                        :info="file.file.size">
                        <z-link :href="file.file.link" blank> {{ file.name }} </z-link>
                    </z-filelist-item>
                </z-filelist>
            </div>
        </div>
        <z-tabs kind="drop" size="m" v-if="foldersWithFiles && foldersWithFiles.length">
            <template v-slot:label>
                <z-tabs-label
                    v-for="(accordion, i) in foldersWithFiles"
                    :key="i"
                    :id="`lable${i}`">{{ accordion.name }}</z-tabs-label>
            </template>
            <template v-slot:content>
                        <z-tabs-content
                            class="row u-top-margin--s-important"
                            v-for="(accordion, i) in foldersWithFiles"
                            :key="i"
                            :id="`lable${i}`">
                                <z-filelist-item
                                    class="col-default-6 col-mobile-12"
                                    v-for="(file, index) in accordion.items"
                                    :key="index"
                                    :icon="`file/${file.file.type}`"
                                    :info="file.file.size">
                                    <z-link :href="file.file.link" blank> {{ file.name }} </z-link>
                                </z-filelist-item>
                        </z-tabs-content>
            </template>
        </z-tabs>
    </div>
</template>

<script>
export default {
    name: 'approach-and-policy',
    data () {
        return {
            items: [],
            foldersWithFiles: []
        }
    },
    created () {
        try {
            this.items = this.$root.app.components['approach-and-policy'].items
            this.foldersWithFiles = this.$root.app.components['approach-and-policy']['items-with-tabs']
        } catch (error) {
            console.log(error)
        }
    }
}
</script>
